import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { useNavigate } from 'react-router-dom'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import URL from '../../constants/urls'
import EventCard from '../../components/global/EventCard'
// import { convertParkingTime } from '../../utils/helper'
import { getFormattedAmountNumber, isTimeBeforeCurrentFacilityTime } from '../../utils/helper'
import { useParams } from 'react-router-dom'

function BookingList({ eventData, noOfEventShow, dispatch, isMainScreen, typeDetails, passId, eventFacility, notify, selectedFacilityId }) {
    const user = window.location.toString().split('/')[3]
    const navigate = useNavigate()
    const { facility } = useParams()
    const [sliceEvent, setSliceEvent] = useState(EMPTY_ARRAY)
    const localFacilityId = JSON.parse(localStorage.getItem('selectedFacilityId'))
    const [facilityDet, setFacilityDet] = useState({
        name: null,
        defaultPrice: getFormattedAmountNumber('0.00')
    })

    const handleBookingButtton = (id = '', facilityID = '') => {
        if (user) {
            if (facility && facility != '') {
                navigate(`/${user}/${URL?.BOOKING_DETAIL}${facilityID ? '/' + facilityID : localFacilityId ? '/' + localFacilityId : ''}${id ? '/' + id : ''}`)
            } else {
                navigate(`${URL?.BOOKING_DETAIL}${facilityID ? '/' + facilityID : localFacilityId ? '/' + localFacilityId : ''}${id ? '/' + id : ''}`)
            }
        } else {
            navigate('*')
        }
    }
    useEffect(() => {
        // console.log(eventData, 'I am here 1')
        if (eventData?.length > 0) {
            setSliceEvent(eventData?.slice(0, noOfEventShow))
        } else {
            setSliceEvent(EMPTY_ARRAY)
        }
    }, [eventData, noOfEventShow])
    useEffect(() => {
        if (eventData?.length > 0 && eventData[0]?.facilities?.length) {
            let facilityName = eventData[0]?.facilities?.filter((item) => item?.id === localFacilityId)
            if (facilityName?.length > 0) {
                setFacilityDet({ ...facilityDet, defaultPrice: facilityName[0]?.base_event_rate, name: facilityName[0]?.full_name })
            }
        }
    }, [])

    return (

        (sliceEvent?.length > 0) ? sliceEvent?.map((item) => {
            // Always recalculate isBookingClosed on every render
            let currentFacilityID = selectedFacilityId ? selectedFacilityId : localStorage?.getItem('selectedFacilityId')

            // Find the facility from item.facilities matching currentFacilityID
            const matchedFacility = item?.facilities?.find(
                (f) => String(f.id) === String(currentFacilityID)
            )

            let facilityTimeZone = matchedFacility?.timezone ? matchedFacility?.timezone : 'America/New_York'
            let isBookingClosed = isTimeBeforeCurrentFacilityTime(item?.stop_event_booking_time, facilityTimeZone)

            return <EventCard
                key={item?.id}
                eventIndex={item?.id}
                handleBookingButtton={handleBookingButtton}
                imageUrl={(item?.image_url) ? item?.image_url : 'NoImage'}
                title={item?.title}
                detials={item?.description}
                startDate={item?.start_time}
                // time={convertParkingTime(item?.parking_start_time, item?.parking_end_time)}
                time={item}
                paybaleAmount={(Number(item?.event_rate) == '0.00' || Number(item?.event_rate) == 0) ? getFormattedAmountNumber(item?.facilities?.[0]?.base_event_rate) : getFormattedAmountNumber(item?.event_rate)}
                id={item?.id}
                isMainScreen={(isMainScreen) ? isMainScreen : false}
                facilitiesName={(facilityDet.name && !eventFacility) ? facilityDet.name : item?.facilities?.[0]?.full_name}
                allFacility={item?.facilities}
                facilityPrice={facilityDet.defaultPrice}
                end_time={item?.end_time}
                typeDetails={typeDetails}
                passId={passId}
                isMultiplefacility={item?.event_facility && item?.event_facility?.length > 1}
                isBookingClosed={isBookingClosed}
                dispatch={dispatch}
                notify={notify}
                currentFacilityID={currentFacilityID}
            />
        }) : <h4 className='w-100 text-primary py-3 text-center'>No events available.</h4>
    )
}

BookingList.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    globalData: PropTypes.object,
    eventData: PropTypes.array,
    noOfEventShow: PropTypes.number,
    isMainScreen: PropTypes.bool,
    typeDetails: PropTypes.string,
    passId: PropTypes.string,
    eventFacility: PropTypes.bool,
    selectedFacilityId: PropTypes.string,
}

BookingList.defaulProps = {
    dispatch: noop,
    globalData: EMPTY_OBJECT,
    notify: noop,
    eventData: EMPTY_ARRAY,
    noOfEventShow: 4,
    isMainScreen: false,
    typeDetails: '',
    passId: '',
    eventFacility: false,
    selectedFacilityId: '',
}

function mapStateToProps({ globalReducers }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        eventData: globalReducers?.allEventsData,
        noOfEventShow: globalReducers?.noOfEventShow
    }
}

export default connect(mapStateToProps)(BookingList)